import React, { useState } from 'react';
import Workspace from '../images/Projects/work.jpeg'
import { Box, styled, Typography, useMediaQuery, Button, Modal, IconButton } from '@mui/material';
import Enum from './../images/Projects/milsatenum.png';
import Vcn from './../images/Projects/VCN.png';
import Nacos from './../images/Projects/nacos.png';
import EkitiPortal from './../images/Projects/EKITI IRS GEOSPATIAL PORTAL.png';
import TidyNest1 from './../images/Projects/cv1.png';

// Close Icon Component
const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
);

// Styled Components
const Image = styled('img')({
  width: '100%',
  height: '250px',
  objectFit: 'cover',
});

const ProjectsGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '40px',
  marginTop: '40px',
  
  '@media (max-width: 1024px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '30px',
  },
  
  '@media (max-width: 768px)': {
    gridTemplateColumns: '1fr',
    gap: '30px',
  },
});

const ProjectCard = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

const CTA = styled(Button)({
  fontSize: '15px',
  fontFamily: 'Oswald',
  border: '1px solid black',
  color: 'black',
  backgroundColor: 'white',
  padding: '20px',
  marginTop: '12px',
  transition: 'all 0.3s ease',
  
  '&:hover': {
    backgroundColor: 'black',
    color: 'white',
    border: '1px solid black',
  },
});

const ReadMoreButton = styled(Button)({
  fontSize: '14px',
  color: 'blue',
  textDecoration: 'underline',
  padding: 0,
  minWidth: 'auto',
  textTransform: 'none',
  
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
});

const FilterButton = styled(Button)({
  fontSize: '14px',
  fontFamily: 'Oswald',
  border: '1px solid black',
  color: 'black',
  backgroundColor: 'white',
  padding: '10px 20px',
  transition: 'all 0.3s ease',
  
  '&:hover': {
    backgroundColor: 'black',
    color: 'white',
  },

  '&.active': {
    backgroundColor: 'black',
    color: 'white',
  },
});

const TypeBadge = styled(Box)(({ type }) => ({
  display: 'inline-block',
  padding: '4px 12px',
  backgroundColor: type === 'personal' ? '#e3f2fd' : '#fff3e0',
  color: type === 'personal' ? '#1976d2' : '#f57c00',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  marginBottom: '8px',
}));

const ModalBox = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '600px',
  backgroundColor: 'white',
  border: '2px solid black',
  boxShadow: '24px',
  padding: '32px',
  maxHeight: '80vh',
  overflowY: 'auto',
});

const CloseIconButton = styled(IconButton)({
  position: 'absolute',
  top: '16px',
  right: '16px',
  color: 'black',
  
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
});

const ContentContainer = styled(Box)({
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 40px',
  
  '@media (max-width: 768px)': {
    padding: '0 20px',
  },
});

const DeployedProjects = () => {
    const desktopView = useMediaQuery('(min-width:1093px)');
    const [openModal, setOpenModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [filterType, setFilterType] = useState('all');

    const handleOpenModal = (project) => {
        setSelectedProject(project);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedProject(null);
    };

    const handleFilterChange = (type) => {
        setFilterType(type);
    };

    const truncateDescription = (description, wordLimit = 30) => {
        const words = description.split(' ');
        if (words.length <= wordLimit) {
            return description;
        }
        return words.slice(0, wordLimit).join(' ') + '...';
    };

    const deployed_projects = [
        {
            id: 1,
            name: 'TidyNest: Building Trust in On-Demand Cleaning service with Technology',
            description: 'This project explores how TidyNest, an on-demand professional cleaning service, can leverage computer vision and spatial data to systematically validate service quality. The application is designed to strengthen reliability, transparency, and trust by supporting consistent service delivery and creating a more dependable experience for customers.',
            url: '/tidynest-project-information',
            image: TidyNest1,
            cta: 'learn more',
            type: 'personal'
        },
        {
            id: 2,
            name: 'milsat enumeration suites: A geospatial data collection system.',
            description: 'An end-to-end location data collection and visualization system designed for businesses and organizations (governmental and non-governmental) to deliver actionable location intelligence, enabling informed decision-making.',
            url: 'https://conscious-college-56f.notion.site/Milsat-Enumeration-Suites-6447753915ab4540a916078199e0b805?pvs=4',
            image: Enum,
            cta: 'learn more',
            type: 'work',
        },
        {
            id: 3,
            name: 'EKITI IRS GEOSPATIAL PORTAL',
            description: 'The platform empowers property owners in Ekiti State to conveniently manage and pay their property taxes online. With easy geo-location of properties and seamless payment options, they can stay on top of their tax obligations from the comfort of their homes.',
            url: 'https://conscious-college-56f.notion.site/EKITI-STATE-IRS-GEOSPATIAL-PORTAL-91839a468bf647a982b41b76648448dc?pvs=4',
            image: EkitiPortal,
            cta: 'learn more',
            type: 'work',
        },
        {
            id: 4,
            name: 'THE VETENARY COUNCIL OF NIGERIA System',
            description: 'In an effort to transition from the conventional operational management of the VCN body, a key aspect of embracing the modern era involves shifting towards the digital transformation of all processes involving over 10,000 practitioners.',
            url: 'https://conscious-college-56f.notion.site/VCN-SYSTEM-6bc7f128762f40c28eb29c72af8d765a?pvs=4',
            image: Vcn,
            cta: 'learn more',
            type: 'work',
        },
        {
            id: 5,
            name: 'utiva school of product: Haven; A workspace product solution platform.',
            description: 'Haven is a B2B2C platform designed to address the needs of professionals, remote workers, and businesses by providing access to convenient and productive workspaces.',
            url: 'https://conscious-college-56f.notion.site/WORKSPACES-afb9f28197774a45a1d26bcbe661f231',
            image: Workspace,
            cta: 'learn more',
            type: 'personal',
        },
        {
            id: 6,
            name: 'the nacos e-library system',
            description: 'A proposed developmental e-libary system for the department of Computer Science, University of ilorin; an alternative to the conventional library.',
            url: 'https://conscious-college-56f.notion.site/The-NACOS-E-Library-System-d99ace4f245e4846962486c08d522d03?pvs=4',
            image: Nacos,
            cta: 'learn more',
            type: 'personal',
        },
    ];

    const filteredProjects = deployed_projects.filter(
        project => filterType === 'all' || project.type === filterType
    );

    return (
        <>
            <Box sx={{ paddingTop: desktopView ? '140px' : '100px', paddingBottom: '80px'}}>
                {/* <Typography style={{ fontFamily: "Oswald", textAlign: 'center', fontSize: '20px' }}>
                    <u>PROJECTS</u>
                </Typography> */}
                <br />
                
                <ContentContainer>
                    <Typography sx={{ fontSize: "20px", marginBottom: '40px', lineHeight: '1.8' }}>
                        This section encompasses a collection of personal, collaborative, and company-level products or works that
                        I've actively been involved in.
                        Each segment offers a concise overview of each work.
                        To delve deeper into my role and contributions to the entire project, simply click on <b>"Learn More"</b> <span>&#128522;</span>.
                        Should you have any questions or express interest in any of these projects,
                        please feel free to reach out to me at <b><a href="mailto:aminatbalogun00@gmail.com">aminatbalogun00@gmail.com</a></b>. Thanks <span>&#129303;</span>!
                    </Typography>

                    {/* Filter Buttons */}
                    <Box sx={{ textAlign: 'center', marginBottom: '40px', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '8px' }}>
                        <FilterButton 
                            className={filterType === 'all' ? 'active' : ''}
                            onClick={() => handleFilterChange('all')}
                        >
                            ALL WORKS
                        </FilterButton>
                        <FilterButton 
                            className={filterType === 'personal' ? 'active' : ''}
                            onClick={() => handleFilterChange('personal')}
                        >
                            PERSONAL
                        </FilterButton>
                        <FilterButton 
                            className={filterType === 'work' ? 'active' : ''}
                            onClick={() => handleFilterChange('work')}
                        >
                            COMPANY
                        </FilterButton>
                    </Box>

                    {/* Projects Grid */}
                    <ProjectsGrid>
                        {filteredProjects.map((project) => {
                            const truncatedDescription = truncateDescription(project.description);
                            const isTruncated = project.description.split(' ').length > 30;

                            return (
                                <ProjectCard key={project.id}>
                                    <Image alt={project.name} src={project.image} />
                                    
                                    <Box sx={{ marginTop: '16px' }}>
                                        <TypeBadge type={project.type}>
                                            {project.type === 'personal' ? 'Personal' : 'Company'}
                                        </TypeBadge>
                                        
                                        <Typography style={{ 
                                            fontFamily: 'Oswald', 
                                            fontSize: '24px', 
                                            letterSpacing: '2px', 
                                            lineHeight: '1.8', 
                                            marginBottom: '12px' 
                                        }}>
                                            {project.name.toUpperCase()}
                                        </Typography>
                                        
                                        <Typography style={{ lineHeight: '1.8', fontSize: '18px', marginBottom: '16px' }}>
                                            {truncatedDescription}
                                            {isTruncated && (
                                                <ReadMoreButton onClick={() => handleOpenModal(project)}>
                                                    Read more
                                                </ReadMoreButton>
                                            )}
                                        </Typography>
                                        
                                        <a href={project.url} target="_blank" rel="noopener noreferrer"
                                            style={{ textDecoration: 'none', color: 'black' }}
                                        >
                                            <CTA>
                                                {project.cta.toUpperCase()}
                                            </CTA>
                                        </a>
                                    </Box>
                                </ProjectCard>
                            );
                        })}
                    </ProjectsGrid>
                </ContentContainer>
            </Box>

            {/* Modal for full description */}
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="project-modal-title"
                aria-describedby="project-modal-description"
                sx={{
                    backdropFilter: 'blur(8px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }}
            >
                <ModalBox>
                    {selectedProject && (
                        <>
                            <CloseIconButton onClick={handleCloseModal} aria-label="close">
                                <CloseIcon />
                            </CloseIconButton>
                            
                            <TypeBadge type={selectedProject.type}>
                                {selectedProject.type === 'personal' ? 'Personal' : 'Company'}
                            </TypeBadge>
                            <Typography 
                                id="project-modal-title" 
                                style={{ 
                                    fontFamily: 'Oswald', 
                                    fontSize: '24px', 
                                    letterSpacing: '2px', 
                                    marginBottom: '16px',
                                    marginTop: '8px',
                                    paddingRight: '40px',
                                    lineHeight: '1.8',
                                }}
                            >
                                {selectedProject.name.toUpperCase()}
                            </Typography>
                            <Image alt={selectedProject.name} src={selectedProject.image} style={{ marginBottom: '16px' }} />
                            <Typography 
                                id="project-modal-description" 
                                style={{ 
                                    lineHeight: '1.8', 
                                    fontSize: '18px', 
                                    marginBottom: '24px',
                                     
                                }}
                            >
                                {selectedProject.description}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                <a href={selectedProject.url} target="_blank" rel="noopener noreferrer"
                                    style={{ textDecoration: 'none', color: 'black' }}
                                >
                                    <CTA>
                                        {selectedProject.cta.toUpperCase()}
                                    </CTA>
                                </a>
                            </Box>
                        </>
                    )}
                </ModalBox>
            </Modal>
        </>
    )
}

export default DeployedProjects;